export const HH_COLON_MM = 'HH:mm';
